(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mig-hero"] && !Shopify.designMode) return;
  try {
    

function initMigIntro(scope=document){scope.querySelectorAll('[data-mig-intro]').forEach(root=>{if(root.dataset.introReady||!root.classList.contains('mig-motion'))return;root.dataset.introReady='true';const reduced=window.matchMedia('(prefers-reduced-motion: reduce)');const button=root.querySelector('[data-mig-replay]');button.hidden=reduced.matches;const onMotion=()=>{button.hidden=reduced.matches};reduced.addEventListener('change',onMotion);button.addEventListener('click',()=>{root.classList.add('mig-intro-reset');requestAnimationFrame(()=>requestAnimationFrame(()=>{if(root.isConnected)root.classList.remove('mig-intro-reset')}))});const observer=new IntersectionObserver(entries=>{if(entries.some(entry=>entry.isIntersecting)){root.classList.add('mig-art-visible');observer.disconnect()}},{threshold:.25});observer.observe(root.querySelector('.mig-hero-art'));root.migCleanup=()=>{observer.disconnect();reduced.removeEventListener('change',onMotion)}})}initMigIntro();document.addEventListener('shopify:section:load',event=>initMigIntro(event.target));document.addEventListener('shopify:section:unload',event=>event.target.querySelectorAll('[data-mig-intro]').forEach(root=>root.migCleanup?.()));


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mig-product"] && !Shopify.designMode) return;
  try {
    
function initMigProducts(){document.querySelectorAll('[data-mig-product]').forEach(root=>{if(root.dataset.ready)return;root.dataset.ready='true';const buttons=Array.from(root.querySelectorAll('[data-mig-colour-button]'));const photo=root.querySelector('[data-mig-photo]');const label=root.querySelector('[data-mig-colour]');function select(button,update){buttons.forEach(item=>item.setAttribute('aria-pressed',String(item===button)));photo.src=button.dataset.image;photo.alt=button.dataset.label+' — MIG';label.textContent=button.dataset.label;if(update)history.replaceState(null,'','#'+button.dataset.migColourButton)}buttons.forEach(button=>button.addEventListener('click',()=>select(button,true)));const initial=buttons.find(button=>button.dataset.migColourButton===location.hash.slice(1));if(initial)select(initial,false);window.addEventListener('hashchange',()=>{const target=buttons.find(button=>button.dataset.migColourButton===location.hash.slice(1));if(target)select(target,false)})})}initMigProducts();document.addEventListener('shopify:section:load',initMigProducts);

  } catch(e) { console.error(e); }
})();
})();
